var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideHeader)?_c('header-module'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"min-1280"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"min-1280"}):_vm._e(),(!_vm.$route.meta.hideLayout)?_c('footer-module'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }